export type CatalogSeoMeta = {
  title: string;
  description: string;
};

export type CatalogSeoMetaInput = {
  cityName?: string | null;
  categoryName?: string | null;
  productName?: string | null;
};

export const formatSeoCityLocation = (cityName?: string | null): string => {
  const normalizedCityName = cityName?.trim();

  return normalizedCityName
    ? `в городе ${normalizedCityName}`
    : 'в вашем городе';
};

export const buildCatalogSeoMeta = ({
  cityName,
  categoryName,
  productName,
}: CatalogSeoMetaInput): CatalogSeoMeta => {
  const cityLocation = formatSeoCityLocation(cityName);

  if (productName) {
    const deliveryCategory = categoryName || 'суши и роллов';

    return {
      title: `${productName} заказать ${cityLocation} | Доставка ${deliveryCategory} на дом от СушиВесла`,
      description: `Закажи ${productName} на дом или в офис ${cityLocation}. Доставка ${deliveryCategory} от СушиВесла.`,
    };
  }

  if (categoryName) {
    return {
      title: `${categoryName} ${cityLocation} | Заказать с доставкой в СушиВесла`,
      description: `Доставка ${categoryName} на дом или в офис ${cityLocation}. Сделай заказ на сайте СушиВесла.`,
    };
  }

  return {
    title: `Доставка суши и роллов ${cityLocation} | Заказать суши, роллы и воки от СушиВесла`,
    description: `Заказать суши, роллы и воки ${cityLocation} на дом или в офис. Акции и программа лояльности СушиВесла.`,
  };
};
